import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { BasicInput, SimplePopover } from '@dev/ee-components';
import { forEach } from 'lodash-es';
import { Grid } from '@material-ui/core';

import { getListstStore } from '@/store/lists/actions';
import { getAccountStore } from '@/store/account/actions';
import {
    AssignContactsListsSelectProps,
} from '../../../ContactsUpload';
import { getDecodedListName } from '../../..';

const enableContactFeatures = (GeneralInfo): boolean => GeneralInfo?.EnableContactFeatures;

export const AssignContactsListsSelect = (props: AssignContactsListsSelectProps): JSX.Element => {
    const { t } = useTranslation();
    const lists = useSelector(getListstStore);
    const { GeneralInfo } = useSelector(getAccountStore);
    const { segmentname, listname } = useParams<{ segmentname: string; listname: string }>();
    const { createList, listName, setListName, isValidListName, setValidListName } = props;

    const contactLists = [
        {
            value: '0',
            label: t('allcontacts'),
        },
    ];
    if (enableContactFeatures(GeneralInfo)) {
        forEach(lists?.collection, (item): void => {
            const paidSubscription = item.Type === 'PaidSubscription';
            if (paidSubscription) return;
            contactLists.push({
                value: item.ListName,
                label: item.ListName,
            });
        });
    }
    const decodedListname = getDecodedListName(listname);

    return (
        <Grid item xs={12} md={6}>
            {!createList && lists?.collection && (
                <SimplePopover
                    id="list-names"
                    options={contactLists}
                    disabled={!!listname || !!segmentname}
                    type="input"
                    label={t('selectlistname')}
                    value={!!decodedListname ? decodedListname : listName}
                    maxHeight={400}
                    fullWidth
                    onItemClick={(_e, obj): void => {
                        setListName(obj.value as string);
                    }}
                />
            )}
            {createList && (
                <BasicInput
                    name="selectlistname"
                    label={t('selectlistname')}
                    placeholder={t('listname')}
                    id="new-list-name-input"
                    type="text"
                    value={listName}
                    onChange={(e): void => {
                        setListName(e.currentTarget.value);
                        setValidListName(true);
                    }}
                    error={!isValidListName}
                    errorMessage={t('thesamelistname')}
                />
            )}
        </Grid>
    );
};